import * as React from 'react';

import { DASHBOARD_BROWSER_AUTH_FAILED_WARNING } from 'src/ui/constants/testIds';
import { copy } from 'src/ui/templates/copy';
import { buildRoute } from 'src/ui/utils/buildRoute';

interface BrowserAuthFailedWarningProps {
  index: number;
  org: string | undefined;
}

export const BrowserAuthFailedWarning: React.VFC<BrowserAuthFailedWarningProps> = ({
  index,
  org,
}) => {
  return (
    <div className="sd-warning">
      {copy.errors.browserAuthFailed.before}
      &nbsp;
      <a
        href={buildRoute(org, index, 'diagnostic')}
        data-testid={DASHBOARD_BROWSER_AUTH_FAILED_WARNING}
      >
        {copy.errors.browserAuthFailed.link}
      </a>
      &nbsp;
      {copy.errors.browserAuthFailed.after}
    </div>
  );
};
